import Axios from 'axios';


class PaymentAPI {
  url: string = `https://prodaja.lo.co.me/paymentAPI/payment.php`;
  urlConfirm: string = `https://prodaja.lo.co.me/mps_api/confirmPayment.php`;
  close(): Promise<any> {
    return Axios.get(`${this.url}`);
  }
  getPage(url:string): Promise<any> {
    return Axios.get(url);
  }
  confirm(calc:number): Promise<any>{
    return Axios.post(this.urlConfirm, {calc})
  }
}

export default PaymentAPI;
